export const fmt = {
  money: (n, currency = "€") => {
    if (n === null || n === undefined || isNaN(n)) return `${currency}0`;
    const abs = Math.abs(n);
    if (abs >= 1e9) return `${currency}${(n / 1e9).toFixed(2)}B`;
    if (abs >= 1e6) return `${currency}${(n / 1e6).toFixed(1)}M`;
    if (abs >= 1e3) return `${currency}${(n / 1e3).toFixed(0)}K`;
    return `${currency}${n.toFixed(0)}`;
  },
  moneyFull: (n, currency = "€") => {
    if (n === null || n === undefined || isNaN(n)) return `${currency}0`;
    return `${currency}${Math.round(n).toLocaleString("en-US")}`;
  },
  pct: (n) => `${Number(n || 0).toFixed(1)}%`,
  num: (n) => Number(n || 0).toLocaleString("en-US"),
  date: (d) => {
    if (!d) return "—";
    try {
      return new Date(d).toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" });
    } catch { return "—"; }
  },
};

export const stageColors = {
  sourcing:   { bg: "rgba(156,163,175,0.1)", text: "#9ca3af", border: "#4b5563" },
  diligence:  { bg: "rgba(59,130,246,0.1)", text: "#60a5fa", border: "#2563eb" },
  negotiation:{ bg: "rgba(168,85,247,0.12)", text: "#c084fc", border: "#7c3aed" },
  closing:    { bg: "rgba(197,160,89,0.15)", text: "#C5A059", border: "#C5A059" },
  closed:     { bg: "rgba(16,185,129,0.1)", text: "#34d399", border: "#10b981" },
  exited:     { bg: "rgba(16,185,129,0.2)", text: "#6ee7b7", border: "#047857" },
};

export const stageLabels = {
  sourcing: "Sourcing",
  diligence: "Due Diligence",
  negotiation: "Negotiation",
  closing: "Closing",
  closed: "Closed",
  exited: "Exited",
};

export const cx = (...classes) => classes.filter(Boolean).join(" ");
